<template>
    <div class="wrapper" :class="{closeSide: !open}">
        <side-bar></side-bar>
        <div class="content-box hasTag">
            <div class="fixed-header">
                <v-header></v-header>
            </div>
            <div class="app-main">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>

                <v-footer></v-footer>
            </div>
        </div>

        <!--密码修改-->
        <el-dialog width="50%" title="密码修改" :visible.sync="passwordVisible" :modal-append-to-body="false" :show-close="false" :close-on-click-modal="false">
            <el-form :model="passwordParams" :rules="passwordRules" ref="amountForm" label-width="140px" class="demo-ruleForm">
                <div class="common-poplist">
                    <ul>
                        <li>
                            <div class="inputdiv">
                                <el-form-item label="原密码" prop="password">
                                    <el-input placeholder="请输入原密码" v-model="passwordParams.password" show-password ></el-input>
                                </el-form-item>
                            </div>
                        </li>
                        <li>
                            <div class="inputdiv">
                                <el-form-item label="新密码" prop="newPassword">
                                    <el-input placeholder="请输入新密码" v-model="passwordParams.newPassword" show-password></el-input>
                                </el-form-item>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="common-popbtn">
                    <el-button @click="passwordBtn" size="small" type="primary">确定</el-button>
                    <el-button @click="passwordExit" size="small">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import sideBar from "@/layouts/components/sideBar";
import vHeader from '@/layouts/components/vHeader';
import vFooter from '@/layouts/components/vFooter';
export default {
    name:"Frame",
    data(){
        return{
            passwordParams:{
                password:'',
                newPassword:'',
            },
            passwordRules:{
                password:[
                    {required:true,message:'请输入原密码',trigger:'blur'},
                ],
                newPassword:[
                    {required:true,message:'请输入新密码',trigger:'blur'},
                ],
            },
        }
    },
    computed:{
        ...mapGetters(['open','applist']),
        ...mapState({
            passwordVisible:state => state.global.passwordVisible,
        }),
    },
    watch:{
        'passwordVisible':{
            handler(newVal){
                if(!newVal){
                    this.passwordParams={
                        password:'',
                        newPassword:'',
                    }
                }
            },
            deep:true,
        },
    },
    methods:{
        ...mapActions({
            getApplist:'APP_LIST'
        }),
        passwordExit(){
            this.$store.commit('PASSWORD_VISIBLE');
        },
        passwordBtn(){
            this.$refs.amountForm.validate((valid)=>{
                if(valid){
                    const loading = this.$loading({lock: true,});
                    this.$http('/sys/user/password',{method:'get',params:this.passwordParams}).then(res=>{
                        this.$message.success(res.message);
                        this.passwordVisible=false;
                        setTimeout(()=>{
                            this.$http('/logout',{method:'get',params:{}}).then(res=>{
                                console.log('退出登录=========>',res);
                                localStorage.removeItem('user');
                                this.$store.dispatch('actionUserSignout');
                                this.$store.dispatch('CLEAR_TAGS');
                                this.$router.replace({path:'/login'});
                                loading.close();
                            }).catch(err=>{
                                loading.close();
                                this.$message.error(err.respMsg)
                            })
                        },500)
                    }).catch(error=>{
                        loading.close();
                        this.$message.error(error.message);
                    })
                }else{
                    return false
                }
            });
        },

    },
    components:{
        sideBar,
        vHeader,
        vFooter,
    },
    mounted(){
        if(this.applist.length===undefined){
            this.getApplist();
        }
        let $searchMore=localStorage.getItem('searchMore') || '';
        if($searchMore===''){
            localStorage.setItem('searchMore','0')
        }
    }
}
</script>

<style rel="stylesheet" lang="scss">
    @import 'components/css/layouts';
</style>



// WEBPACK FOOTER //
// src/layouts/Frame.vue